import { api } from '../../core/network/api';

export type DistrictOwner = 'you' | 'rival' | 'neutral';

/** Never seen a single cell of this turf — total fog. No name, no art, nothing. */
export interface UnknownDistrict {
  districtId: string;
  visibility: 'unknown';
}

/** Scouted (walked near it on the City Map) — basic intel only, no income figures. */
export interface SeenDistrict {
  districtId: string;
  visibility: 'seen';
  name: string;
  family: string;
  tier: number;
  unlockLevel: number;
  locked: boolean;
  owner: 'rival' | 'neutral';
  defense: number;
}

/** You run this turf — full operational detail. */
export interface OwnedDistrict {
  districtId: string;
  visibility: 'owned';
  name: string;
  family: string;
  tier: number;
  unlockLevel: number;
  locked: false;
  owner: 'you';
  level: number;
  racket: string;
  income: number;
  defense: number;
  pendingIncome: number;
  storageCap: number;
  readyToCollect: boolean;
  atStorageCap: boolean;
  upgradeCost: number | null;
  maxLevel: boolean;
}

export type District = UnknownDistrict | SeenDistrict | OwnedDistrict;

export interface CollectResult { collected: number; cash: number; districtId: string }

export interface UpgradeResult {
  districtId: string;
  level: number;
  racket: string;
  income: number;
  defense: number;
  spent: number;
  cash: number;
  upgradeCost: number | null;
  maxLevel: boolean;
}

export const fetchDistricts = () =>
  api.get<{ districts: District[] }>('/territories').then((r) => r.districts);

export const collectDistrict = (districtId: string) =>
  api.post<CollectResult>(`/territories/${districtId}/collect`, {});

export const upgradeDistrict = (districtId: string) =>
  api.post<UpgradeResult>(`/territories/${districtId}/upgrade`, {});
